module.exports = __webpack_public_path__ + "static/media/twitterLogo.3f097837.png";